module.exports = __webpack_public_path__ + "static/media/emoji.825d327f.svg";